/* eslint-disable no-unused-vars */
export enum IdleStateEnum {
    NOT_IDLE = 'not idle',
    IDLE = 'idle',
    TIMED_OUT = 'timed out',
    ACTIVE_CHECK = 'active check'
}
